import Popup from "./Popup.tsx";
import {useCallback, useEffect, useState} from "react";
import {notice, NoticeAPIConnectorError} from "../../lib/notice.ts";
import {BlueshiftAPIConnectorError} from "../../lib/api.ts";
import {et} from "../../locales/i18n.tsx";
import type {NoticePopup} from "../../lib/ModelTypes.ts";

interface ContentProps {
    pathname: string
}

const NoticePopupManager = ({pathname}: ContentProps) => {
    const [popups, setPopups] = useState<NoticePopup[]>([]);

    const getPopupCollection = useCallback(async () => {
        try {
            const noticeId: number[] = []
            const locationData = await notice.getPopups();
            locationData.map(async (item) => {
                if (item.location === window.location.pathname) {
                    if (!noticeId.includes(item.notice_id)) {
                        noticeId.push(item.notice_id);
                    }
                }
            })
            if (noticeId.length > 0) {
                const promises = noticeId.map(async (item) => {
                    return await getNotice(item)
                });
                const results = await Promise.all(promises);
                setPopups(results);
            }
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new NoticeAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }

    }, []);

    useEffect(() => {
        setPopups([]);
        getPopupCollection().finally();
    }, [getPopupCollection, pathname]);


    async function getNotice(noticeId: number) {
        try {
            return await notice.getPopup(noticeId);

        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new NoticeAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    }

    return (
        popups.map(item => (
            item ?
                <Popup key={item.id} popup={item}/> :
                null
            )
        )
    )
}

export default NoticePopupManager;